module.exports = __webpack_public_path__ + "static/media/Bảo Sơn.11185f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/TestimonialsCarousel/assets/partner/Bảo Sơn.png
// module id = 1109
// module chunks = 0